import { render, staticRenderFns } from "./StudentPhotoManager.vue?vue&type=template&id=177e84e9&scoped=true&"
import script from "./StudentPhotoManager.vue?vue&type=script&lang=ts&"
export * from "./StudentPhotoManager.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPhotoManager.vue?vue&type=style&index=0&id=177e84e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e84e9",
  null
  
)

export default component.exports